import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import StoreContext from "./../../../Store/Context";
import DatatableExpand from "../../Constants/DatatableExpand";
import {
  Row,
  Col,
  Label,
  Container,
  Table,
  Button,
  ButtonGroup,
} from "reactstrap";
import { SEARCH_ICON } from "../../Constants/SrcImages";
import {
  COLUMNS_GRADES,
  EXPAND_ROW_GRADE_CUENTAS,
} from "../../Constants/DatatableColumns";
import { PaginationHeaderYear,BODY_CUENTAS_REPORT,GET_SUM_T_PAGO } from "./../../Constants/Util";
import {
  getGrades,
  getMonto,
  getRegistrationCuenta,
  save_cxcr_matricula,
  update_cxcr_matricula,
  getCxc,
  save_cxcr_mensualidad,
  getcxc_cobrar,
  getRPagoDetail
} from "../../Constants/Services";
import {
  IFormDetalle,
  IDropDates,
  ICxcTDetail,
  ICxcDetail,
  IFormMatricula2,
  IRegistration,
  IGrades,
  IGradeSelected,
  IMonto,
  IMontoDate,
  Icxc_cobrar,
  IRDPago
} from "./../../Constants/Interfaces";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface ICuentasState {
  dataCxcDetail: ICxcDetail[];
  dataCxcT: ICxcTDetail[];
  formCobrarCuota: ICxcDetail;
  dropDates: IDropDates[];
  formMonto: IMonto;
  dataMontoDate: IMontoDate[];
  dataRegistration: IRegistration[];
  dataRegistrationSelected: IRegistration;
  dataGrades: IGrades[];
  formMatricula: IFormMatricula2;
  formDetalle: IFormDetalle;
  dataGradeSelected: IGradeSelected;
  cxcd_cxcdetail: string;
  isOpenModalCuentas: boolean;
  isOpenModalAddCuentas: boolean;
  isOpenModalAddCuota: boolean;
  isOpenModalEditCuota: boolean;
  isOpenModalCxcDetalle: boolean;
  isOpenModalCxcEditDetalle: boolean;
  loading: boolean;
  msg_error: string;
  year: string;
  cxc_cobrar: Icxc_cobrar[];
  dataFormRPagoD: IRDPago;
  dataRPagoD: IRDPago[];
}

class Cuentas extends Component<RouteComponentProps<{}>, ICuentasState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dropDates: [],
      dataRegistration: [],
      dataCxcDetail: [],
      dataCxcT: [],
      dataMontoDate: [],
      cxc_cobrar: [],
      formMonto: {
        mt_id: "",
        mt_grade: "",
        mt_year: "",
        mt_mensualidad_r: "",
        mt_mensualidad_hm: "",
        mt_mensualidad_hd: "",
        mt_matricula_r: "",
        mt_matricula_hm: "",
        mt_matricula_hd: "",
        mt_plataforma: "",
        mt_laboratorio: "",
        mt_efisica: "",
        mt_otro_monto: "",
        mt_otro_desc: "",
        mt_anualidad_r: "",
        mt_anualidad_hm: "",
        mt_anualidad_hd: "",
        mt_a_plataforma: "",
        mt_a_laboratorio: "",
        mt_a_robotica:"",
        mt_robotica:"",
        mt_a_efisica: "",
        t_status: "",
      },
      dataFormRPagoD: {
        rpd_id: "",
        rpd_monto: "",
        rpd_tpago: "",
        rpd_secuencia:"",
        rpd_cxc:"",
        tp_desc: "",
      },
      dataRPagoD:[],
      formCobrarCuota: {
        cxc_id: "",
        cxc_cxcobrar_reg: "",
        cxc_cuota: "",
        cxc_mes: "",
        cxc_stado: "",
        me_stado: "",
        cxc_saldo: "",
        cxc_moro: "",
        cxc_morostado: "",
        moro_stado: "",
        cxc_date: "",
        mtd_id: "",
        mtd_mes_number: "",
        mtd_date: "",
      },
      cxcd_cxcdetail: "",
      formMatricula: {
        cxcr_id: "",
        cxcr_registration: "",
        cxcr_tcuenta: "",
        cxcr_matricula: "",
        cxcr_mensualidad: "",
        cxcr_stado: "",
        cxcr_saldo: "",
        cxcr_status: "",
        cxcr_date: "",
        cxcr_anualidad: "",
        cxcr_s_anualidad: "",
        cxcr_saldo_cole: "",
        cxcr_anualidad_state: "",
        cxcr_debep: "",
        per_cedula:"",
        reg_grade:""
      },
      formDetalle: {
        cxcd_id: "",
        cxcd_cxcdetail: "",
        cxcd_type: "1",
        cxcd_type_desc: "",
        cxcd_monto: "",
        cxcd_stado: "",
        cxcd_saldo: "",
      },
      dataRegistrationSelected: {
        per_id: "",
        per_cedula: "",
        per_name: "",
        per_lastname: "",
        per_status: "",
        per_birthday: "",
        reg_id: "",
        reg_new: "",
        reg_complete: "",
      },
      dataGrades: [],
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
      },
      isOpenModalCuentas: false,
      isOpenModalAddCuentas: false,
      isOpenModalAddCuota: false,
      isOpenModalEditCuota: false,
      loading: false,
      isOpenModalCxcDetalle: false,
      isOpenModalCxcEditDetalle: false,
      msg_error: "",
      year: new Date().getFullYear().toString(),
    };
    this.fetchCxc = this.fetchCxc.bind(this);
    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchRegistration = this.fetchRegistration.bind(this);
    this.handlerSearchCuenta = this.handlerSearchCuenta.bind(this);
    this.columnModalSearchCuentas = this.columnModalSearchCuentas.bind(this);
    this.handlerGoback = this.handlerGoback.bind(this);
    this.handlerSaveMatricula = this.handlerSaveMatricula.bind(this);
    this.setDataTypoMatricula = this.setDataTypoMatricula.bind(this);
    this.onChangeData = this.onChangeData.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.fetchMonto = this.fetchMonto.bind(this);
    this.changeHeader = this.changeHeader.bind(this);
    this.fetchcxc_cobrar = this.fetchcxc_cobrar.bind(this);
    this.setDataModoDePago = this.setDataModoDePago.bind(this);
  }

  async fetchRPagoDetail(props:any) {
    const response = await getRPagoDetail(
      props.per_id + props.per_cedula.replace(/\D/g, "") + + props.reg_id
    );
    var result = 0;
    response.map((data, i) => {
        result = Number(result) + Number(data.rpd_monto);
      return null;
    });
    this.setState({
      dataRPagoD: response,
      dataFormRPagoD: {
        rpd_id: "",
        rpd_monto: "",
        rpd_tpago: "",
        tp_desc: "", 
        rpd_secuencia:"",
        rpd_cxc:"",
      },
      // dataFormRPago: {
      //   ...this.state.dataFormRPago,
      //   rp_pagoTotal: Number(result).toFixed(2).toString(),
      // },
      loading: false,
    });
  }

  async fetchMonto({ gr_id }) {
    const response = await getMonto(gr_id, this.context.year);
    var matricula = "";
    var mensualidad = "";
    if (response.mt !== undefined && response.mtd !== undefined) {
      if (this.state.formMatricula.cxcr_tcuenta === "3") {
        matricula = response.mt[0].mt_matricula_hd;
        mensualidad = response.mt[0].mt_mensualidad_hd;
      } else if (this.state.formMatricula.cxcr_tcuenta === "2") {
        matricula = response.mt[0].mt_matricula_hm;
        mensualidad = response.mt[0].mt_mensualidad_hm;
      } else {
        matricula = response.mt[0].mt_matricula_r;
        mensualidad = response.mt[0].mt_mensualidad_r;
      }

      this.setState({
        formMonto: response.mt[0],
        dataMontoDate: response.mtd,
        dropDates: response.m_dates,
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_matricula: matricula,
          cxcr_mensualidad: mensualidad,
        },
        loading: false,
        msg_error: "",
      });
    } else {
      this.setState({
        dataMontoDate: [],
        formMonto: {
          mt_a_robotica:"",
          mt_robotica:"",
          mt_id: "",
          mt_grade: "",
          mt_year: "",
          mt_mensualidad_r: "",
          mt_mensualidad_hm: "",
          mt_mensualidad_hd: "",
          mt_matricula_r: "",
          mt_matricula_hm: "",
          mt_matricula_hd: "",
          mt_plataforma: "",
          mt_laboratorio: "",
          mt_efisica: "",
          mt_otro_monto: "",
          mt_otro_desc: "",
          mt_anualidad_r: "",
          mt_anualidad_hm: "",
          mt_anualidad_hd: "",
          mt_a_plataforma: "",
          mt_a_laboratorio: "",
          mt_a_efisica: "",
          t_status: "",
        },
        loading: false,
        msg_error:
          "No tienes montos o fechas de mensualidades registrados en este grado",
      });
    }
  }

  async fetchRegistration({ gr_id, gr_desc }: IGradeSelected) {
    const response = await getRegistrationCuenta(gr_id, this.state.year);
    this.setState({
      dataRegistration: response,
      dataGradeSelected: { gr_id, gr_desc },
      msg_error: "",
    });
  }

  async fetchcxc_cobrar(reg_id: string) {
    const response = await getcxc_cobrar(reg_id, this.state.year);
    this.setState({
      cxc_cobrar: response,
      loading: false,
      msg_error: "",
    });
  }

  async fetchCxc(reg_id: string) {
    const response = await getCxc(reg_id, this.state.year);

    // if (response.length > 0) {
    if (response[0] !== undefined) {
      this.setState({
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_id: response[0].cxcr_id,
          cxcr_registration: response[0].cxcr_registration,
          cxcr_tcuenta: response[0].cxcr_tcuenta,
          cxcr_stado: response[0].cxcr_stado,
          cxcr_saldo: response[0].cxcr_saldo,
          cxcr_status: response[0].cxcr_status,
          cxcr_date: response[0].cxcr_date,
          cxcr_anualidad: response[0].cxcr_anualidad,
          cxcr_saldo_cole: response[0].cxcr_saldo_cole,
          cxcr_anualidad_state: response[0].cxcr_anualidad_state,
          per_cedula:response[0].per_cedula
        },
        loading: false,
        msg_error: "",
      });
      this.fetchcxc_cobrar(reg_id);
    }

    this.fetchMonto({ gr_id: this.state.dataGradeSelected.gr_id });
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrades: response,
      loading: false,
      msg_error: "",
    });
  }

  componentDidMount() {
    this.fetchGrade();
  }

  handlerSearchCuenta = (row: any) => {
    this.setState((prevState) => ({
      isOpenModalCuentas: !prevState.isOpenModalCuentas,
      dataRegistrationSelected: row,
      formMatricula: {
        cxcr_id: "",
        cxcr_registration: "",
        cxcr_tcuenta: "",
        cxcr_matricula: "",
        cxcr_mensualidad: "",
        cxcr_stado: "",
        cxcr_saldo: "",
        cxcr_status: "",
        cxcr_date: "",
        cxcr_anualidad: "",
        cxcr_s_anualidad: "",
        cxcr_saldo_cole: "",
        cxcr_anualidad_state: "",
        mtd_id: "",
        mtd_mes_number: "",
        cxcr_debep: "",
        per_cedula:"",
        reg_grade:""
      },
      cxc_cobrar:[],
      dataCxcDetail: [],
      dataCxcT: [],
      dataMontoDate: [],
      dropDates: [],
      msg_error: "",
    }));
    this.fetchCxc(row.reg_id);
    this.fetchRPagoDetail(row);
  };

  handlerSaveMatricula() {
    const props = this.state.formMatricula;
    const propsReg = this.state.dataRegistrationSelected;
    if (props.cxcr_id.length > 0) {
      if(props.cxcr_anualidad_state==="1"){
        const body = {
          cxcr_id: props.cxcr_id,
          cxcr_tcuenta: props.cxcr_tcuenta,
          cxcr_matricula: props.cxcr_matricula,
          cxcr_anualidad: props.cxcr_anualidad,
        };
  
        update_cxcr_matricula(body);
      }
      else{
        const body = {
          cxcr_id: props.cxcr_id,
          cxcr_tcuenta: props.cxcr_tcuenta,
          cxcr_matricula: props.cxcr_matricula,
          cxcr_mensualidad: props.cxcr_mensualidad,
        };
  
        update_cxcr_matricula(body);
      }

      setTimeout(() => {
        this.fetchCxc(props.cxcr_registration);
      }, 1000);
    } else {
      if (props.cxcr_tcuenta.length > 0 && props.cxcr_anualidad_state.length >0 ) {
        const body = {
          cxcr_registration: propsReg.reg_id,
          cxcr_tcuenta: props.cxcr_tcuenta,
          cxcr_matricula: props.cxcr_matricula,
          cxcr_year: this.state.year,
          cxcr_mensualidad: props.cxcr_mensualidad,
          cxcr_anualidad: props.cxcr_anualidad,
          cxcr_anualidad_state: props.cxcr_anualidad_state,
        };
        var rows = [];
        var num=11;
        if(props.cxcr_anualidad_state==="1"){
          num = 2;
        }

        for (var i = 1; i < num; i++) {
          rows.push({
            cxc_cxcobrar_reg: propsReg.reg_id,
            cxc_cuota: i,
          });
        }
        save_cxcr_matricula(body);
        save_cxcr_mensualidad(rows);
        setTimeout(() => {
          this.fetchCxc(propsReg.reg_id);
        }, 1000);

      } else {
        this.setState({ msg_error: "Marca el  tipo de cuenta y el modo de pago!" });
      }

    }
  }

  onChangeData(e: any) {
    this.setState({
      formMatricula: {
        ...this.state.formMatricula,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
    });
  }

  setDataModoDePago(target: string) {
    const props = this.state.formMonto;
    var anualidad = "";
    if (target === "1") {
      if(this.state.formMatricula.cxcr_tcuenta==="1"){
        anualidad = props.mt_anualidad_r;
      }
      else if(this.state.formMatricula.cxcr_tcuenta==="2"){
        anualidad = props.mt_anualidad_hm;
      }
      else if(this.state.formMatricula.cxcr_tcuenta==="3"){
        anualidad = props.mt_anualidad_hd;
      }
    }
    this.setState({
      formMatricula: {
        ...this.state.formMatricula,
        cxcr_anualidad_state: target,
        cxcr_anualidad:anualidad
      },
      msg_error: "",
    });
  }

  setDataTypoMatricula(target: string) {
    const props = this.state.formMonto;
    var matricula = "";
    var mensualidad = "";
    var anualidad = "";

    if (target === "3") {
      matricula = props.mt_matricula_hd;
      mensualidad = props.mt_mensualidad_hd;
      anualidad = props.mt_anualidad_hd;
    } else if (target === "2") {
      matricula = props.mt_matricula_hm;
      mensualidad = props.mt_mensualidad_hm;
      anualidad = props.mt_anualidad_hm;
    } else {
      matricula = props.mt_matricula_r;
      mensualidad = props.mt_mensualidad_r;
      anualidad = props.mt_anualidad_r;
    }

    if(this.state.formMatricula.cxcr_anualidad_state==="1"){
      this.setState({
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_tcuenta: target,
          cxcr_matricula: matricula,
          cxcr_mensualidad: mensualidad,
          cxcr_anualidad: anualidad,
        },
        msg_error: "",
      });
    }
    else{
      this.setState({
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_tcuenta: target,
          cxcr_matricula: matricula,
          cxcr_mensualidad: mensualidad,
          cxcr_anualidad: "",
        },
        msg_error: "",
      });

    }
  }

  handlerGoback() {
    this.setState((prevState) => ({
      isOpenModalCuentas: !prevState.isOpenModalCuentas,
    }));
  }

  columnModalSearchCuentas(cell, row) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Label
            className="txt-underline"
            onClick={() => this.handlerSearchCuenta(row)}
          >
            {row.per_cedula}
          </Label>
          <img
            className="img-search-icon"
            onClick={() => this.handlerSearchCuenta(row)}
            src={SEARCH_ICON}
            alt=""
          />
        </Col>
      </Row>
    );
  }

  rechargeData() {
    const props = this.state.dataRegistrationSelected;
    this.setState({ loading: true, msg_error: "" });
    setTimeout(() => {
      this.fetchCxc(props.reg_id);
    }, 1000);
  }

  changeHeader({ year, operation }: any) {
    var currentYear = new Date();
    var result = year;
    if (operation === "left") result = parseInt(year) - 1;
    else {
      result = parseInt(year) + 1;
      if (result > currentYear.getFullYear())
        result = currentYear.getFullYear();
    }
    this.setState({
      year: result,
    });
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Container className="mt-4">
          {props.isOpenModalCuentas &&
          props.formMonto.mt_id.length > 0 &&
          props.dataMontoDate.length > 0 ? (
            <React.Fragment>
              <Row className="mt-5">
                <Col xs={6} className="text-left">
                  <h4 className="font-weight-bold">
                    {`${props.dataRegistrationSelected.per_name} ${props.dataRegistrationSelected.per_lastname} ${props.dataGradeSelected.gr_desc}`}
                  </h4>
                </Col>
                <Col xs={6} className="text-right">
                  <ClipLoader
                    css={override}
                    size={23}
                    color={"#36D7B7"}
                    loading={this.state.loading}
                  />
                  <Button
                    color="success"
                    className="mr-2"
                    onClick={() => this.rechargeData()}
                  >
                    Recargar
                  </Button>
                  <Button color="primary" onClick={() => this.handlerGoback()}>
                    Cerrar
                  </Button>
                </Col>
              </Row>
              <Row className="mt-5 mb-3">
                <Col xs={2} className="text-left lh-40">
                  <Label className="font-weight-bold">Tipo de cuenta:</Label>
                </Col>
                <Col xs={10} className="text-left">
                  <ButtonGroup>
                    <Button
                      color="primary"
                      outline
                      onClick={() => this.setDataTypoMatricula("1")}
                      active={props.formMatricula.cxcr_tcuenta === "1"}
                    >
                      Regular
                    </Button>
                    <Button
                      color="success"
                      outline
                      onClick={() => this.setDataTypoMatricula("2")}
                      active={props.formMatricula.cxcr_tcuenta === "2"}
                    >
                      Hermano
                    </Button>
                    <Button
                      color="info"
                      outline
                      onClick={() => this.setDataTypoMatricula("3")}
                      active={props.formMatricula.cxcr_tcuenta === "3"}
                    >
                      Hijo de docente
                    </Button>
                  </ButtonGroup>
                </Col>
                {
                  props.formMatricula.cxcr_tcuenta.length>0?
                  <React.Fragment>
                     <Col xs={2} className="text-left lh-40">
                  <Label className="font-weight-bold">Modo de pago:</Label>
                </Col>
                <Col xs={7} className="text-left">
                  {
                    props.dataRPagoD.length>0?
                    <React.Fragment>
                      <ButtonGroup>
                    <Button
                      color="primary"
                      outline
                      disabled
                      active={props.formMatricula.cxcr_anualidad_state === "1"}
                    >
                      Anual
                    </Button>
                    <Button
                      color="success"
                      outline
                      disabled
                      active={props.formMatricula.cxcr_anualidad_state === "2"}    
                    >
                      Mensual
                    </Button>
                  </ButtonGroup>
                    </React.Fragment>
                    :
                    <React.Fragment>
                       <ButtonGroup>
                    <Button
                      color="primary"
                      outline
                      onClick={() => this.setDataModoDePago("1")}
                      active={props.formMatricula.cxcr_anualidad_state === "1"}
                    >
                      Anual
                    </Button>
                    <Button
                      color="success"
                      outline
                      onClick={() => this.setDataModoDePago("2")}
                      active={props.formMatricula.cxcr_anualidad_state === "2"}    
                    >
                      Mensual
                    </Button>
                  </ButtonGroup>
                    </React.Fragment>
                  }
                 
                </Col>
                <Col xs={3} className="text-right lh-40">
                  <Button
                    color="danger"
                    onClick={() => this.handlerSaveMatricula()}
                  >
                    Guardar perfil
                  </Button>
                </Col>
                  </React.Fragment>
                  :
                  null
                }
               
                <Col xs={12} className="text-right">
                  <Label className="l-color-danger">
                    {props.msg_error.length > 0 ? props.msg_error : null}
                  </Label>
                </Col>
                {props.cxc_cobrar.length > 0 ? (
                  <React.Fragment>
                    <Col xs={12} className="mt-3 text-center info">
                      <Label>
                        <b>COLEGIATURA</b>
                      </Label>
                    </Col>
                    <Col xs={12}>
                      <Table bordered>
                        <thead>
                          <tr>
                            <th className="text-center">
                              <b>Tipo de pago</b>
                            </th>
                            <th className="text-center">
                              <b>Monto</b>
                            </th>
                            <th className="text-center">
                              <b>Cancelado</b>
                            </th>
                            <th className="text-center">
                              <b>Por pagar</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <Row className="text-center">
                                <Col xs={12}>
                                  <b>Matricula</b>
                                </Col>
                              </Row>
                            </td>
                            <td>
                              {" "}
                              <Row className="text-center">
                                <Col xs={12}>
                                  {props.formMatricula.cxcr_matricula}
                                </Col>
                              </Row>
                            </td>
                            <td>
                              {" "}
                              <Row className="text-center">
                                <Col xs={12}>
                                  {                  props.formMatricula.cxcr_stado === "1"
                                  ? GET_SUM_T_PAGO(
                                      props.dataRPagoD,
                                      "2",
                                      false,
                                      null
                                    ).toFixed(2)
                                  : "B/."}
                                </Col>
                              </Row>
                            </td>
                            <td>
                              {" "}
                              <Row className="text-center">
                                <Col xs={12}>
                                {                  props.formMatricula.cxcr_stado === "1"
                                  ?
                                  (
                                    Number(props.formMatricula.cxcr_matricula) -
                                    Number(                                   GET_SUM_T_PAGO(
                                      props.dataRPagoD,
                                      "2",
                                      false,
                                      null
                                    ).toFixed(2))
                                  ).toFixed(2)

                                  : "B/."}

 
                                </Col>
                              </Row>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      <Col xs={12}>
                      <BODY_CUENTAS_REPORT props={props}/>
                      </Col>
                     
                    </Col>
                  </React.Fragment>
                ) : null}
              </Row>
            </React.Fragment>
          ) : (
            <Row>
              <Col sm={12} className="text-center">
                <Label className="font-weight-bold">
                  <h3>Cuentas</h3>
                </Label>
              </Col>
              <Col sm={12} className="text-left">
                <Label className="l-color-danger">{props.msg_error}</Label>
              </Col>
              <Col sm={12} className="text-center">
                <PaginationHeaderYear
                  year={props.year}
                  changeHeader={this.changeHeader}
                />
              </Col>
              <Col sm={12}>
                <DatatableExpand
                  data={props.dataGrades}
                  columns={COLUMNS_GRADES()}
                  keyProp="gr_id"
                  expandRow={EXPAND_ROW_GRADE_CUENTAS(
                    this.fetchRegistration,
                    props.dataRegistration,
                    this.columnModalSearchCuentas
                  )}
                  exportD={false}
                  searchs={false}
                />
              </Col>
            </Row>
          )}
        </Container>
      </React.Fragment>
    );
  }
}
export default Cuentas;